import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=8e270f8a"
import script from "./AdminSettings.vue?vue&type=script&lang=ts"
export * from "./AdminSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports